<template>
    <div class="profile">
        <Navbar></Navbar>
        <main id="main" class="container-fluid clearfix">

            <div class="wrapper full-width">
                <!-- #my_profile -->
                <div id="my_profile" class="sidebar sidebar-1 dark-mode">
                    <div class="inner">
                        <div class="profile-header">
                            <div class="profile-header-left">
                                <div>
                                    <span class="name">{{user.name}}</span>
                                    <span class="role">{{ user.role }}</span>
                                    <div>
                                        <router-link :to="'/profile/edit/' + user.id">
                                            <button class="edit-info">Edit Info</button>
                                        </router-link>
                                    </div>
                                </div>
                            </div>

                            <div class="profile-header-right">
                                <span class="joined">Joined: {{ date_format(user.createdDate, 'DD.MM.YYYY') }}</span>
                                <span v-if="user.lastSignedInAt" class="last-seen">Last Seen: {{ date_format(user.lastSignedInAt, 'DD.MM.YYYY') }}</span>
                            </div>
                        </div>
                        <div class="profile-body">
                            <div class="row profile-lists-group">
                                <div class="col-xl-5 col-lg-12 col-md-12 col-sm-12">
                                    <!-- .profile-lists -->
                                    <div class="profile-lists">
                                        <h4>Personal Details</h4>
                                        <div class="table-responsive">
                                            <table class="profile-list">
                                                <tr>
                                                    <th>Name</th>
                                                    <td>{{user.name}}</td>
                                                </tr>
                                                <tr>
                                                    <th>Role</th>
                                                    <td>{{ user.role }}</td>
                                                </tr>
                                                <tr>
                                                    <th>Email</th>
                                                    <td>{{user.email}}</td>
                                                </tr>
                                                <tr>
                                                    <th>Phone Number</th>
                                                    <td>{{user.phone}}</td>
                                                </tr>
                                                <tr>
                                                    <th>Country</th>
                                                    <td>{{countryName(user.country)}} {{user.country}}</td>
                                                </tr>
                                                <tr v-if="user.country == 'USA'">
                                                    <th>State</th>
                                                    <td>{{user.state}}</td>
                                                </tr>
                                                <tr>
                                                    <th>City</th>
                                                    <td>{{user.city}}</td>
                                                </tr>
                                                <tr>
                                                    <th>Address</th>
                                                    <td>{{user.address1}}</td>
                                                </tr>
                                                <tr>
                                                    <th>Zip</th>
                                                    <td>{{user.zipcode}}</td>
                                                </tr>
                                                <tr>
                                                    <th>Fax</th>
                                                    <td>{{user.fax}}</td>
                                                </tr>
                                                <tr>
                                                    <th>Signature</th>
                                                    <td  class="signatureImage"></td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div><!-- end .profile-lists -->
                                </div>
                                <div class="col-xl-7 col-lg-12 col-md-12 col-sm-12">
                                    <!-- .permisssions-lists -->
                                    <div class="profile-lists permisssions-lists-group">
                                        <h4>My Permisssions</h4>
                                        <div class="permisssions-lists">
                                            <div class="profile-list" v-for="(item, item_index) in permissions"
                                                 :key="item_index">
                                                <h5>{{ item.label}}</h5>
                                                <ul>
                                                    <li v-for="(permission, permission_index) in item.data"
                                                        :key="permission_index">
                                                            <span v-if="matched(user.permissions, permission.value)">
                                                            {{ permission.name }}</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div><!-- end .permisssions-lists -->
                                    </div><!-- end .permisssions-lists-group -->
                                </div>
                            </div><!-- end .profile-lists-group -->
                        </div>
                        <router-link :to="'/'" class="back-to-dash">
                            <span class=""> Back to Dashboard</span>
                        </router-link>
                    </div>
                </div>
                <!-- end #my_profile -->

            </div>

        </main>
    </div>
</template>
<script>
    import Navbar from '../layouts/components/TheNavbar.vue';
    import UserService from "../services/UserService";
    import countries from './countries';
    import moment from 'moment';

    export default {
        name: 'Profile',
        components: {
            Navbar
        },

        data() {
            return {
                roles: {},
                user: {
                    permissions: [],
                },
                countries: countries,
                permissionIds: [],
                permissions: [
                    {
                        label: 'User',
                        data: []
                    },
                    {
                        label: 'Patient',
                        data: []
                    },
                    {
                        label: 'Study',
                        data: []
                    },
                    {
                        label: 'Report',
                        data: []

                    },

                    {
                        label: 'Gallery',
                        data: []

                    }
                ],
            }
        },

        async created() {
            this.getUserById(this.$route.params.id);
            this.getAllPermissions();
        },

        methods: {
            async getUserById(id) {
                await UserService.getUserDataById(id)
                    .then((response) => {
                        console.log(response)
                        this.user = response;
                    })
                    .catch((error) => {
                        console.log(error);
                    });
                this.$store.commit('setLoading', false)
            },

            async getAllPermissions() {
                await UserService.getPermissions()
                    .then((response) => {

                        for(let i = 0; i < this.permissions.length; i++) {

                            for (const [key, value] of Object.entries(response)) {
                                if(this.permissions[i].label === 'Study') {
                                    if(value.includes(this.permissions[i].label) && !value.includes('Report')) {
                                        const temp = {
                                            name: value,
                                            label: key,
                                            value: key,
                                            checked: false
                                        }
                                        this.permissions[i].data.push(temp)
                                    }
                                }
                                else {
                                    if(value.includes(this.permissions[i].label)) {
                                        const temp = {
                                            name: value,
                                            label: key,
                                            value: key,
                                            checked: false
                                        }
                                        this.permissions[i].data.push(temp)
                                    }
                                }

                            }

                        }

                    })
                    .catch((error) => {
                        console.log(error);
                    });
            },

            date_format(date, format) {
                return (date) ? moment(date).format(format) : null;
            },

            countryName(code) {
                let country = {}
                if (typeof code !== "undefined") {
                    country = this.countries.find(obj => obj.code === code);
                    if (typeof country !== "undefined") {
                        return country.name;
                    }
                    return null;

                }
                return null;

            },

            matched(permissions, permission) {
                return permissions.includes(permission);
            },
        }

    }
</script>
<style scoped>
    .back-to-dash  {
        font-size: 14px;
        color: #FFFFFF !important;
        background-color: transparent;
        border: none;
    }

    .back-to-dash span {
        display:inline-block;
        padding-left: 20px;
        color: #00D5FF;
    }
</style>